<mat-icon (click)="close()">close</mat-icon>
<img src="assets/imgs/login_popup.jpg" (click)="login()">


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/event.details/login.with.facebook.modal/login.with.facebook.modal.html